<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormulario" name="nomFormulario">

    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOCICLO.LBL_MODALIDAD' | translate }}</label>
          <p-dropdown disableTab  id="idModalidad" name="nomModalidad" [options]="lisModalidad"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                       formControlName="idModalidad"
                      (onChange)="validarModalidad()"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idModalidad.invalid">
            {{ 'PERFILRIESGOCICLO.LBL_MODALIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOTASAS.LBL_TASAEA' | translate }}</label>
          <label class="falso-combo-texto" >{{f.tasaModalidad.value }}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tasaModalidad.invalid">
            {{ 'PERFILRIESGOTASAS.LBL_TASAEA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOTASAS.LBL_TASAPERIODICA' | translate }}</label>
          <label class="falso-combo-texto" >{{f.tasaPeriodica.value | numero:6}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tasaPeriodica.invalid">
            {{ 'PERFILRIESGOTASAS.LBL_TASAPERIODICA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>



    <div class="grid form-group">
      <div class="col-12 md:col-2 lg:col-2">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOTASAS.LBL_PUNTODISMINUCION' | translate }} (%)</label>
          <input type="text" pInputText id="idPuntoDisminucion"
                 name="nomPuntoDisminucion"
                 autocomplete="off"
                 formControlName="puntosDisminucion"
                 [maxlength]="6" (blur)="validarTasa()"
                 porcentaje-reactive [decimales]="3"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.puntosDisminucion.invalid">
            {{ 'PERFILRIESGOTASAS.LBL_PUNTODISMINUCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="supTasa">
            {{ 'PERFILRIESGOTASAS.MSG_SUPERATASA' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2 lg:col-2">
        <div class="div-form">
          <br/>
          <p-checkbox label="{{ 'PERFILRIESGOTASAS.LBL_INDICADORSUMA' | translate}}" binary="true"
                      id="indicadorSuma"
                      name="nomIndicadorSuma"
                      formControlName="indicadorSuma"></p-checkbox>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOTASAS.LBL_MONTOMINIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
          <label class="falso-combo-texto">{{f.montoMinimo.value}}</label>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'PERFILRIESGOTASAS.LBL_MONTOMAXIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
          <input type="text" pInputText id="idMontoMaximo"
                 name="nomMontoMaximo"
                 autocomplete="off"
                 formControlName="montoMaximo" numero-decimal-reactive [decimales]="6" [entero]="7" [minimo]="0"
                 [maxlength]="14"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
            {{ 'PERFILRIESGOTASAS.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
            {{ 'LBL_RANGOINVALIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" *ngIf="!carRiesgoTasa"
               [value]="getPerfilesRiesgoTasas" selectionMode="single" dataKey="idPerfilRiesgoVariacionMonto"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-i="rowIndex">
          <tr [pSelectableRow]="row">
            <td>{{row.nombreModalidad}}</td>
            <td>{{row.tasaModalidad}}</td>
            <td>{{(row.tasaPeriodica * 100) | numero:6}}</td>
            <td>{{row.indicadorSuma ? '+' : '-'}}{{row.puntosDisminucion}}</td>
            <td>{{row.montoMinimo}}</td>
            <td>{{row.montoMaximo}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton *ngIf="lisPerfilesRiesgoTasas.length-1 === i || row.indicadorEliminar"
                        (click)="deshabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons" *ngIf="perfil.indicadorManejaCiclos">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-right" label="{{'BTN_SIGUIENTE' | translate }}"
              type="submit" (click)="irSiguiente()"
              pButton></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="tasa">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
